module.exports = __webpack_public_path__ + "media/images/custom-8b939cae.png";